import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { Shimmer, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import AddonsItemLoading from '../../Components/AddonsItemLoading';

import { loadingConfig, shimmerPlaceholderConfig } from './AddOnsLoading.Config';
import styles from './AddOnsLoading.styles';

const renderAddonsItemsLoading = numberOfAddonsLoadingItems => {
  const addonsLoadingItems = [];
  for (let i = 0; i < numberOfAddonsLoadingItems; i++) {
    addonsLoadingItems.push(<AddonsItemLoading key={i} />);
  }
  return addonsLoadingItems;
};

const AddOnsLoading = ({ containerStyle, numberOfAddonsLoadingItems }) => {
  const theme = useTheme();
  return (
    <View style={[styles.container, containerStyle]}>
      <Shimmer config={loadingConfig(theme)} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
      <View style={styles.titleAndSubtitleContainer}>
        <VFText i18nKey={'manage_addon_addons_title'} style={styles.subheaderTitle(theme)} />
        <VFText
          i18nKey={'manage_addon_active_addon_title'}
          style={styles.subheaderSubtitle(theme)}
        />
      </View>
      {renderAddonsItemsLoading(numberOfAddonsLoadingItems)}
    </View>
  );
};

AddOnsLoading.defaultProps = {
  numberOfAddonsLoadingItems: 3,
};

AddOnsLoading.propTypes = {
  containerStyle: ViewPropTypes.style,
  numberOfAddonsLoadingItems: PropTypes.number,
};

export default AddOnsLoading;
